import { render, staticRenderFns } from "./CompBookingModal.vue?vue&type=template&id=5a3944fe&scoped=true"
import script from "./CompBookingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBookingModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompBookingModal.vue?vue&type=style&index=0&id=5a3944fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3944fe",
  null
  
)

export default component.exports